import { render, staticRenderFns } from "./UmkmBermitraView.vue?vue&type=template&id=a93892f8&scoped=true"
import script from "./UmkmBermitraView.vue?vue&type=script&lang=js"
export * from "./UmkmBermitraView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93892f8",
  null
  
)

export default component.exports